module.exports = __webpack_public_path__ + "static/media/Plain.637e7c65.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Plain.woff
// module id = 952
// module chunks = 0 1 2 3 4 5 6 7 9